import classNames from 'classnames/bind';
import { ReactComponent as InstagramLogo }  from './IG_Logo.svg'
import styles from './Footer.module.scss';

const cn = classNames.bind(styles);

const Header = (): JSX.Element => {
    const today = new Date();
    const year = today.getFullYear();

    return (
        <footer className={cn('footer')}>
           
                <div >
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.instagram.com/vilniusbarbellgym/"
                        className={cn('icon')}
                    >
                        <InstagramLogo
                        />
                    </a>
                </div>
                <div> © {year} Vilnius Barbell Gym </div>
           
        </footer>
    );
};

export default Header;
